import { TranslateService } from "@ngx-translate/core";
import { Currency } from "src/app/models/Lookup";
import Swal from "sweetalert2";
import { OrderDiscountType, PaymentDetails, ValueTypeEnum } from "./CheckOut.models";
import { CheckOutService } from "./CheckOut.service";

export class CheckOutActions {
  actionLoading!: string | boolean;
  currentOrderId!: number;
  discountList: any[] = [];
  manualDiscount = false;
  manualSurcharge = false;
  currency!: Currency

  openCheckout = false;
  openPaymentDetails = false;

  activePayment!: PaymentDetails | null;

  constructor(
    public checkoutService: CheckOutService,
    public translate: TranslateService
  ) {
    this.checkoutService.checkOutDone.next(false);
  }

  counter(i: number) { return new Array(i); }

  ResGetDiscountList() {
    this.checkoutService.ResGetDiscountList(this.currentOrderId)
      .subscribe(
        data => {
          this.discountList = data as [];
        }, err => {
          console.error(err);
        });
  }
  applyTotalDiscount() {
    Swal.fire({
      title: this.translate.instant('checkout.Apply total discount?'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.actionLoading = true;
        this.checkoutService.ResApplyTotalDiscount(this.currentOrderId)
          .subscribe(
            data => {
              this.actionLoading = false;
              this.checkoutService.refreshView.next(true);
            }, error => {
              this.actionLoading = false;
              Swal.fire({
                title: this.translate.instant('swalMsg.Failed'),
                text: error.detail,
                icon: 'error',
                confirmButtonText: this.translate.instant('swalMsg.I got it')
              });
            });
      }
    });
  }
  applyDiscount(type: string, params: any, hasDiscount: any = false, voucherCode = '') {
    let data = {
      orderId: this.currentOrderId,
      discountType: type,
      discountId: (type == OrderDiscountType.Manual) ? 0 : params,
      discountValue: params.value,
      manualDiscountType: params.valueType || '',
      hasDiscount,
      voucherCode
    }
    this.ResApplyOrderDiscount(data);
  }
  ResApplyOrderDiscount(data: any) {
    let title = this.translate.instant('checkout.Apply Discount?');
    let html = '';
    if (data.hasDiscount) {
      html += '<div class="font-22 fontMedium mb-3">'
        + this.translate.instant('checkout.This Order already has discount, Override it?')
        + ' (' + this.currency.currencyCode + ' ' + data.hasDiscount + ')'
        + '</div>'
    }
    if (data.discountValue) {
      html += '<span class="font-20">'
        + (data.manualDiscountType == ValueTypeEnum.Percentage ? '%' : this.currency.currencyCode)
        + '</span> <span class="font-20 fontSemiBold">'
        + data.discountValue
        + '</span>';
    }
    if (data.discountType == 'RestaurantVoucherLoyalityPoints') {
      html += '<div class="font-22 fontMedium mb-3">'
        + this.translate.instant('checkout.ApplyRestaurantVoucherText')
        + '</div>'
    }
    if (data.voucherCode) {
      title = this.translate.instant('checkout.Apply Promo Code?');
    }
    Swal.fire({
      title,
      html: html,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.actionLoading = true;
        this.checkoutService.ResApplyOrderDiscount(data)
          .subscribe(
            data => {
              this.actionLoading = false;
              this.checkoutService.refreshView.next(true);
            }, error => {
              this.actionLoading = false;
              Swal.fire({
                title: this.translate.instant('swalMsg.Failed'),
                text: error.detail,
                icon: 'error',
                confirmButtonText: this.translate.instant('swalMsg.I got it')
              });
            });
      }
    });
  }
  ResApplySurcharge(params: any) {
    let html = '<span class="font-20">'
      + (params.valueType == ValueTypeEnum.Value ? this.currency.currencyCode : '%')
      + '</span> <span class="font-20 fontSemiBold">'
      + params.value
      + '</span>';
    Swal.fire({
      title: this.translate.instant('checkout.Apply Surcharge?'),
      html: html,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        let data = {
          orderId: this.currentOrderId,
          surchargeValue: Number(params.value),
          surchargeType: params.valueType,
        }
        this.actionLoading = true;
        this.checkoutService.ResApplySurcharge(data)
          .subscribe(
            data => {
              this.actionLoading = false;
              this.checkoutService.refreshView.next(true);
            }, error => {
              this.actionLoading = false;
              Swal.fire({
                title: this.translate.instant('swalMsg.Failed'),
                text: error.detail,
                icon: 'error',
                confirmButtonText: this.translate.instant('swalMsg.I got it')
              });
            });
      }
    });
  }
  ResRemoveOrderDiscount() {
    Swal.fire({
      title: this.translate.instant('checkout.Remove Discount?'),
      text: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.actionLoading = true;
        this.checkoutService.ResRemoveOrderDiscount(this.currentOrderId)
          .subscribe(
            data => {
              this.actionLoading = false;
              this.checkoutService.refreshView.next(true);
            }, error => {
              this.actionLoading = false;
              Swal.fire({
                title: this.translate.instant('swalMsg.Failed'),
                text: error.detail,
                icon: 'error',
                confirmButtonText: this.translate.instant('swalMsg.I got it')
              });
            });
      }
    });
  }
  ResRemoveOrderSurcharge() {
    Swal.fire({
      title: this.translate.instant('checkout.Remove Surcharge?'),
      text: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.actionLoading = true;
        this.checkoutService.ResRemoveOrderSurcharge(this.currentOrderId)
          .subscribe(
            data => {
              this.actionLoading = false;
              this.checkoutService.refreshView.next(true);
            }, error => {
              this.actionLoading = false;
              Swal.fire({
                title: this.translate.instant('swalMsg.Failed'),
                text: error.detail,
                icon: 'error',
                confirmButtonText: this.translate.instant('swalMsg.I got it')
              });
            });
      }
    });
  }

  closeOrderLoading = false;
  closeOrder() {
    Swal.fire({
      title: this.translate.instant('checkout.Close Order?'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.actionLoading = true;
        this.closeOrderLoading = true;
        this.checkoutService.ResCloseOrder(this.currentOrderId)
          .subscribe(
            data => {
              this.actionLoading = false;
              this.closeOrderLoading = false;
              this.checkoutService.refreshView.next(true);
            }, error => {
              this.actionLoading = false;
              this.closeOrderLoading = false;
              Swal.fire({
                title: this.translate.instant('swalMsg.Failed'),
                text: error.detail,
                icon: 'error',
                confirmButtonText: this.translate.instant('swalMsg.I got it')
              });
            });
      }
    });
  }

  applyItemDiscount(item: any, quantity: number) {
    if (Number(item.freeQuantity) > Number(item.quantity)) return;
    this.actionLoading = true;
    let data = {
      orderId: this.currentOrderId,
      id: item.id,
      quantity: Number(quantity)
    }
    this.checkoutService.ResApplyItemDiscount(data)
      .subscribe(
        data => {
          this.actionLoading = false;
          this.checkoutService.refreshView.next(true);
        }, error => {
          this.actionLoading = false;
          this.closeOrderLoading = false;
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.I got it')
          });
          this.checkoutService.refreshView.next(true);
        });
  }

  // Adding Tip
  addTipManual(data: any) {
    if (data?.value) {
      let html = '';
      if (data.value) {
        html = '<span class="font-20">'
          + this.currency.currencyCode
          + '</span> <span class="font-20 fontSemiBold">'
          + data.value
          + '</span>';
      }
      Swal.fire({
        title: this.translate.instant('checkout.Add Tip?'),
        html: html,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('swalMsg.Yes'),
        cancelButtonText: this.translate.instant('swalMsg.No')
      }).then((result) => {
        if (result.value && this.activePayment) {
          this.ResAddTip(this.activePayment.checkOutId, data.value, 'details');
        }
        this.activePayment = null;
      });
    } else {
      this.activePayment = null;
    }
  }
  ResAddTip(checkOutId: number, tipValue: number, actionType = 'checkout') {
    this.actionLoading = true;
    let data = {
      orderId: this.currentOrderId,
      checkOutId,
      tipValue
    }
    this.checkoutService.ResAddTip(data)
      .subscribe(response => {
        this.actionLoading = false;
        if (actionType != 'details') {// After payment confirmation pop up when checkout
          this.checkoutService.checkOutDone.next(true);
        }
        if (actionType == 'details') { // In payment details list
          this.checkoutService.refreshView.next(true);
        }
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('checkout.Tip Added Successfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
      }, err => {
        console.error(err);
      });
  }

  ResNoTip(checkOutId: number) {
    this.actionLoading = true;
    let data = {
      orderId: this.currentOrderId,
      checkOutId
    }
    this.checkoutService.ResAddTip(data)
      .subscribe(response => {
        this.actionLoading = false;
        this.checkoutService.checkOutDone.next(true);
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('checkout.No Tip Added'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok')
        });
      }, err => {
        console.error(err);
      });
  }

  PrintOrderPriceList() {
    this.actionLoading = true;
    this.checkoutService.ResPrentOrderPriceList(this.currentOrderId).subscribe((data: any) => {
      this.actionLoading = false;
      if (!localStorage.getItem('deviceId')) {
        setTimeout(() => { this.print(data.htmlContent); }, 500);
      }
    }, err => {
      console.log(err);
    })
  }

  print(html: string): void {
    const mywindow: any = window.open('', 'PRINT', 'height=600,width=700');
    mywindow.document.write(html);

    mywindow.document.close();
    mywindow.focus();

    mywindow.onload = () => {
      mywindow.print();
    };
  }
}
